import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { cn } from '#app/utils/misc'

interface PricingFeature {
	text: string
}

interface PricingCardProps {
	name: string
	price: number
	discountPrice?: number
	description: string
	features: PricingFeature[]
	isPopular?: boolean
	isCurrentPlan?: boolean
	onSelect?: () => void
	buttonText?: string
}

export function PricingCard({
	name,
	price,
	discountPrice,
	description,
	features,
	isPopular = false,
	isCurrentPlan = false,
	onSelect,
	buttonText = 'Get Started',
}: PricingCardProps) {
	return (
		<div
			className={cn(
				'flex transform flex-col overflow-hidden rounded-xl border-2 border-gray-200 shadow-md',
				isPopular && 'border-indigo-600',
				isCurrentPlan && 'border-green-600',
			)}
		>
			{isPopular && (
				<div className="bg-indigo-600 p-1 text-center text-sm font-semibold">
					MOST POPULAR
				</div>
			)}
			{isCurrentPlan && (
				<div className="bg-green-600 p-1 text-center text-sm font-semibold">
					CURRENT PLAN
				</div>
			)}
			<div
				className={cn(
					'border-b p-6',
					isPopular && 'border-indigo-600',
					isCurrentPlan && 'border-green-600',
				)}
			>
				<h3 className="text-2xl font-bold">{name}</h3>
				<div className="mt-4 flex items-baseline">
					{discountPrice !== undefined ? (
						<>
							<span className="text-2xl font-medium text-gray-500 line-through">
								${price}
							</span>
							<span className="ml-2 text-4xl font-extrabold text-indigo-600">
								${discountPrice}
							</span>
						</>
					) : (
						<span className="text-4xl font-extrabold">${price}</span>
					)}
					<span className="ml-1 text-xl font-semibold text-gray-500">
						/month
					</span>
				</div>
				<p className="mt-5">{description}</p>
			</div>
			<div className="flex flex-1 flex-col justify-between px-6 pb-8 pt-6">
				<ul className="flex-1 space-y-4">
					{features.map((feature, index) => (
						<li key={index} className="flex items-start">
							<Icon name="check" className="text-green-500" />
							<span className="ml-3">{feature.text}</span>
						</li>
					))}
				</ul>
				<div className="mt-8 flex">
					<Button
						onClick={onSelect}
						disabled={isCurrentPlan}
						variant="outline"
						className={cn(
							'w-full',
							isPopular && 'bg-indigo-600 hover:bg-indigo-700',
							isCurrentPlan && 'bg-green-600 hover:bg-green-700',
						)}
					>
						{buttonText}
					</Button>
				</div>
			</div>
		</div>
	)
}
